import {
  Component,
  OnInit,
  Input,
  Optional,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseInputDirective } from '../base-input.directive';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { ErrorService } from '../../services/form-utility/error.service';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-text-area-input',
  templateUrl: './text-area-input.component.html',
  styleUrls: ['./text-area-input.component.scss'],
})
export class TextAreaInputComponent extends BaseInputDirective implements OnInit, AfterViewInit {
  @Input() showCharacterCount: boolean = true;
  @Input() minRows: number = 2;
  @Input() valueOverride;

  showTrimmedText: boolean;
  noteIsLong: boolean;
  trimmedText: string;

  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
    private changeDetector: ChangeDetectorRef,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();

    if (!this.controlName && !this.formControl) {
      this.formControl = new FormControl(this.valueOverride);
      this.evaluateDisabled(this.disabled);
    }
  }

  ngAfterViewInit() {
    const value = this.valueOverride?.toString() ?? this.formControl?.value?.toString() ?? '';
    if (value.length > 200) {
      this.noteIsLong = true;
      this.showTrimmedText = true;
      this.trimmedText = value.substring(0, 200) + '...';
    } else if (value.split(/\r\n|\r|\n/).length > 5) {
      this.noteIsLong = true;
      this.showTrimmedText = true;
      const splits = value.split(/\r\n|\r|\n/);
      this.trimmedText = splits.slice(0, 5).join('\n') + '...';
    }
    this.changeDetector.detectChanges();
  }
}
